import { executeMutation } from 'services/graphQL/clientService.js';
import gql from 'graphql-tag';

const mutation = gql`
  mutation RemoveReward($input: RemoveTeamRewardInput!) {
    removeTeamReward(input: $input) {
      success
      errors
    }
  }
`;

export default function removeReward(input) {
  return executeMutation(mutation, { input });
}
